import { createSelector } from '@reduxjs/toolkit';

import choiceSelector from '@/features/choice/selectors/choice';
import flattenFilterGridItemsSelector from '@/features/config/selectors/flattenFilterGridItems';
import { IChoiceFilters } from '@/interfaces/choice.interfaces';

const filtersChoiceSelector = createSelector(
  [flattenFilterGridItemsSelector, choiceSelector],
  (filterGridItems, { filters }) => {
    const filterItemKeys = filterGridItems.map(item => item.key);

    return Object.entries(filters).reduce((acc, [filterKey, filterValue]) => {
      const isValidFilter = filterItemKeys.includes(filterKey);
      if (!isValidFilter) {
        return acc;
      }
      return {
        ...acc,
        [filterKey]: filterValue,
      };
    }, {} as IChoiceFilters);
  },
);

export default filtersChoiceSelector;
